import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import { MoleculeCard, MoleculeGoal } from '@/components/molecules'
import { IDataCommission, IOrientationGoal } from '@/types';
import { Goal } from '@/core/model';

interface IProps {
  name: string;
  row: IDataCommission[],
  email: string;
  iconBrand: string;
  badgeText: string
  badgeColor: string
  badgeTextColor: string
  isProgress?: boolean
  progress?: number
  orientation: IOrientationGoal[]
  goal: Goal
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeCardGoals',
  props: {
    name: {},
    row: {},
    email: {},
    iconBrand: {},
    badgeText: {},
    badgeColor: {},
    badgeTextColor: {},
    isProgress: { type: Boolean },
    progress: {},
    orientation: {},
    goal: {}
  },
  emits: ['handleLoad'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props

function handleLoad() {
  emit('handleLoad');
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    elevation: "0",
    class: "card-goal"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_item, null, {
        default: _withCtx(() => [
          _createVNode(_unref(MoleculeGoal), {
            name: props.name,
            email: props.email,
            progress: props.progress,
            iconBrand: props.iconBrand,
            row: props.row,
            badgeText: props.badgeText,
            badgeTextColor: props.badgeTextColor,
            badgeColor: props.badgeColor,
            orientation: props.orientation,
            isProgress: props.isProgress,
            goal: props.goal,
            onHandleLoad: handleLoad
          }, null, 8, ["name", "email", "progress", "iconBrand", "row", "badgeText", "badgeTextColor", "badgeColor", "orientation", "isProgress", "goal"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})